import { render, staticRenderFns } from "./LanguageAreaSettingView.vue?vue&type=template&id=ba01f7ca&scoped=true&"
import script from "./LanguageAreaSettingView.vue?vue&type=script&lang=js&"
export * from "./LanguageAreaSettingView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba01f7ca",
  null
  
)

export default component.exports